module.exports = __webpack_public_path__ + "static/media/MaxiNutrition_Proteincoach-Step-5-Milch-alternative-img.59b0790e.png";